import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IApiToken } from '../../../httpClient/serverApi/types/IApiToken';

export class DeleteApiTokenRequest extends Request<Object, any> {
  constructor(tokenId: string) {
    super('deleteApiToken', {'apiToken' : <IApiToken>{'id' : tokenId}});
  }
}
